import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import moment from "moment";

import {
  Modal,
  Box,
  Slider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  IconButton,
  FormHelperText,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import axios from "axios";
import CustomInput from "../../../shared/utils/Input";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ModalToCreateJobBatches = ({
  setOpenModalToCreateJobBatches,
  openModalToCreateJobBatches,
  selectedJobs,
  campaignData,
  availableJobs,
  setSelectedJobs,
  fetchAllJobsBasedOnCampaignId,
  serviceName,
  serviceTypeDynamic,
  setSnackbar,
}) => {
  //   const [open, setOpen] = useState(false);

  const [distance, setDistance] = useState(10); // Slider for Distance
  const [maxDistanceAmongJobs, setMaxDistanceAmongJobs] = useState(10); // Slider for Radius
  const [maxJobs, setMaxJobs] = useState(4); // Slider for Jobs
  // const [availableJobs, setAvailableJobs] = useState([]);
  const [createBatchLoading, setCreateBatchLoading] = useState(false);

  const [availableBatches, setAvailableBatches] = useState([]);
  const [jobDetails, setJobDetails] = useState({
    paymentAmount: null,
    startDate: "",
    endDate: "",
  });
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let newErrors = {};

    if (!jobDetails.paymentAmount || jobDetails.paymentAmount <= 0) {
      newErrors.paymentAmount = "Payment Amount must be greater than 0";
    }

    if (!jobDetails.startDate) {
      newErrors.startDate = "Start date is required";
    }

    if (!jobDetails.endDate) {
      newErrors.endDate = "End date is required";
    }

    // Ensure end date is not before start date
    if (
      jobDetails.startDate &&
      jobDetails.endDate &&
      jobDetails.endDate < jobDetails.startDate
    ) {
      newErrors.endDate = "End date cannot be earlier than start date";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors)?.length === 0;
  };

  const [expandedBatch, setExpandedBatch] = React.useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] =
    React.useState(false);

  // styles :
  const tableCellStyle = {
    borderBottom: "1px solid #ddd",
    color: "#36383A",
    fontSize: "14px",
  };

  // handlers
  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setJobDetails((prevData) => {
      const updatedData = { ...prevData, [name]: value };

      // Validate end date when it's changed
      if (
        name === "endDate" &&
        updatedData.startDate &&
        value < updatedData.startDate
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          endDate: "End date cannot be earlier than start date",
        }));
      } else if (
        name === "startDate" &&
        updatedData.endDate &&
        updatedData.endDate < value
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          endDate: "End date cannot be earlier than start date",
        }));
      } else {
        setErrors((prevErrors) => {
          const updatedErrors = { ...prevErrors };
          delete updatedErrors[name]; // Remove error for this field when valid
          return updatedErrors;
        });
      }

      return updatedData;
    });
  };

  const handleClose = () => setOpenModalToCreateJobBatches(false);
  // Modal styles

  const [saveButtonActive, setsaveButtonActive] = useState(true);
  const fetchAllBatchesBasedOnJobs = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      console.log("Validation failed", errors);
      return;
    }

    const token = localStorage.getItem("token");

    try {
      setCreateBatchLoading(true);
      // 1.send phone number
      const locations = selectedJobs.map((job) => ({
        storeOwnerPhoneNumber: job.storeOwnerPhoneNumber,
        locationCoordinates: job.locationCoordinates,
        id: job._id,
      }));

      // 2.separate jobs by store owner phoneNumber
      const uniqueLocations = [];

      const seenPhones = new Set();

      for (const job of selectedJobs) {
        const phone = job.storeOwnerPhoneNumber;

        if (!seenPhones.has(phone)) {
          seenPhones.add(phone);
          uniqueLocations.push({
            storeOwnerPhoneNumber: phone,
            locationCoordinates: job.locationCoordinates,
            id: job._id,
          });
        }
      }

      // 3. send the new jobs to server
      const responseFromClusterAPI = await axios.post(
        `${process.env.REACT_APP_URL}/batchOfJobs/assignClusters`,
        {
          locationsToCreateClusters: uniqueLocations,
          minLimitOfJobsInCluster: maxJobs,
          maximumDistance: maxDistanceAmongJobs,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (responseFromClusterAPI?.data?.success) {
        setCreateBatchLoading(false);

        setsaveButtonActive(false);
        //4. get the created clusters, input pending jobs of same location(store owner phone number)
        const newBatches = responseFromClusterAPI?.data?.clusters.map(
          (cluster, i) => ({
            batchTitle: `Batch ${i + 1}`,
            jobCompletionDate: jobDetails.endDate,
            jobStartingDate: jobDetails.startDate,
            // paymentAmount: jobDetails.paymentAmount * cluster.jobs?.length,
            paymentAmountPerJob: jobDetails.paymentAmount,
            serviceType: serviceTypeDynamic, // 0 for recce
            // totalNumberOfJobs: cluster.jobs?.length,
            centroidCoordinates: cluster.center,
            distanceFromInstallationPartner: distance,
            jobs: selectedJobs.filter((filterJob) =>
              cluster.jobs.some(
                (job) =>
                  job.storeOwnerPhoneNumber === filterJob.storeOwnerPhoneNumber,
              ),
            ),
          }),
        );

        setAvailableBatches(newBatches);
      }
    } catch (error) {
      console.error("Error while fetching batches", error);
      setCreateBatchLoading(false);
    }
  };

  const saveCreatedBatches = async () => {
    try {
      const token = localStorage.getItem("token");
      const responseFromSaving = await axios.post(
        `${process.env.REACT_APP_URL}/batchOfJobs/create`,
        {
          availableBatches,
          jobDetails,
          campaignId: campaignData,
          partner:
            serviceName === "Recce" || serviceName === "Installation"
              ? "IP"
              : "VP",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (responseFromSaving?.data.success) {
        setOpenConfirmationModal(false);
        setOpenModalToCreateJobBatches(false);
        setSelectedJobs([]);

        fetchAllJobsBasedOnCampaignId();
        setSnackbar({
          open: true,
          message: "Batches Created Successfully",
          severity: "success",
        });
      }
    } catch (error) {
      console.error("Error while saving created batches", error);
    }
  };
  return (
    <div>
      <Modal open={openModalToCreateJobBatches} onClose={handleClose}>
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-full max-w-5xl bg-white p-6 rounded-lg shadow-lg">
            {/* Header */}
            <div className="flex justify-between items-center border-b pb-3">
              <h2 className="text-xl font-semibold">Create Batches</h2>
              <button
                onClick={handleClose}
                className="text-gray-500 hover:text-gray-700"
              >
                ✖
              </button>
            </div>

            <div className="flex flex-col lg:flex-row gap-6 mt-4">
              {/* Left Panel */}
              <div className="w-full lg:w-1/3 p-4 bg-gray-100 rounded-lg">
                {/* Distance */}
                <div className="mb-4">
                  <label className="text-sm font-medium">
                    Distance from Installation Partner*
                  </label>
                  <div className="flex items-center gap-4">
                    <Slider
                      value={distance}
                      onChange={(e, val) => setDistance(val)}
                      min={1}
                      max={100}
                    />
                    <p className="text-gray-600 w-1/4">{distance} Kms</p>
                  </div>
                </div>

                {/* Max Jobs */}
                <div className="mb-4">
                  <label className="text-sm font-medium">
                    {`Maximum Stores in a Batch*`}
                  </label>
                  <div className="flex items-center gap-4">
                    <Slider
                      value={maxJobs}
                      onChange={(e, val) => setMaxJobs(val)}
                      min={1}
                      max={50}
                    />
                    <p className="text-gray-600 w-1/4">{`${maxJobs} Stores`}</p>
                  </div>
                </div>

                {/* Maximum Distance */}
                <div className="mb-4">
                  <label className="text-sm font-medium">
                    Maximum Distance Among Stores*
                  </label>
                  <div className="flex items-center gap-4">
                    <Slider
                      value={maxDistanceAmongJobs}
                      onChange={(e, val) => setMaxDistanceAmongJobs(val)}
                      min={1}
                      max={200}
                    />
                    <p className="text-gray-600 w-1/4">
                      {maxDistanceAmongJobs} Kms
                    </p>
                  </div>
                </div>

                {/* Job Timeline */}
                <div className="relative flex flex-col gap-2 mb-4">
                  <div className="mb-4">
                    <label className="text-sm font-medium">
                      Starting Date of Jobs*
                    </label>
                    <CustomInput
                      name="startDate"
                      placeholder="Enter Start Date"
                      size="small"
                      type="date"
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        const today = new Date().toISOString().split("T")[0];
                        if (selectedDate >= today) {
                          handleInputChange(e);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            startDate: "",
                          }));
                        } else {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            startDate:
                              "Start date must be today or in the future",
                          }));
                        }
                      }}
                      value={jobDetails?.startDate}
                      min={dayjs().format("YYYY-MM-DD")}
                      error={errors.startDate}
                    />
                    {errors.startDate ? (
                      <FormHelperText sx={{ color: "#ff5555" }}>
                        {errors.startDate}
                      </FormHelperText>
                    ) : null}
                  </div>

                  <div className="mb-4">
                    <label className="text-sm font-medium">
                      Ending Date Of Jobs*
                    </label>
                    <CustomInput
                      name="endDate"
                      placeholder="Enter Last Date"
                      size="small"
                      type="date"
                      onChange={(e) => handleInputChange(e)}
                      value={jobDetails?.endDate}
                      error={errors.endDate}
                    />
                    {errors.endDate ? (
                      <FormHelperText sx={{ color: "#ff5555" }}>
                        {errors.endDate}
                      </FormHelperText>
                    ) : null}
                  </div>
                </div>

                {/* Pay per Job */}
                {/* {serviceName === "Recce" && ( */}
                <div className="mb-4">
                  <label className="text-sm font-medium">
                    {`Pay for Each Job*`}
                  </label>
                  <CustomInput
                    size="small"
                    type="number"
                    name="paymentAmount"
                    placeholder="Enter Amount"
                    value={jobDetails.paymentAmount}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Only update if value is positive or empty
                      if (
                        value === "" ||
                        (Number(value) >= 0 && value.length <= 10)
                      ) {
                        handleInputChange(e);
                      }
                    }}
                    onKeyDown={(e) => {
                      const allowed = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];

                      // block any key that is not a digit or a navigation key
                      if (
                        !/^[0-9]$/.test(e.key) && // not a digit
                        !allowed.includes(e.key)
                      ) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => {
                      // Prevent the input value from changing on mouse wheel scroll
                      e.target.blur();
                      e.preventDefault();
                    }}
                    className="w-full p-2 border rounded-lg"
                    error={errors.paymentAmount}
                  />
                  {errors.paymentAmount && (
                    <FormHelperText sx={{ color: "#ff5555" }}>
                      {errors.paymentAmount}
                    </FormHelperText>
                  )}
                </div>
                {/* )} */}

                <GlobalButton
                  variant="primary"
                  size="medium"
                  isLoading={createBatchLoading}
                  onClick={(e) => fetchAllBatchesBasedOnJobs(e)}
                >
                  {`Create Batches`}
                </GlobalButton>
              </div>

              {/* Right Panel: Batch Preview */}
              {availableBatches?.length === 0 ? (
                <div className="w-full lg:w-2/3">
                  <h3 className="text-lg font-semibold mb-2">{`Total Jobs: ${selectedJobs?.length}`}</h3>
                  {selectedJobs?.length === 0 ? (
                    <div className="flex items-center justify-center h-full text-gray-500">
                      No jobs selected. Please select jobs to create batches.
                    </div>
                  ) : (
                    <Box sx={{ overflow: "auto", maxHeight: "500px" }}>
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow sx={{ backgroundColor: "#e0f2fe" }}>
                              {" "}
                              <TableCell
                                sx={{ ...tableCellStyle, width: "25%" }}
                              >
                                City
                              </TableCell>
                              <TableCell
                                sx={{ ...tableCellStyle, width: "45%" }}
                              >
                                Address
                              </TableCell>
                              <TableCell
                                sx={{ ...tableCellStyle, width: "30%" }}
                              >
                                Store Manager
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {selectedJobs?.map((row) => (
                              <TableRow key={row._id}>
                                <TableCell>{row.city}</TableCell>
                                <TableCell>
                                  <LocationAddressComponent
                                    storeName={row.storeName}
                                    address={row.address}
                                    city={row.city}
                                    state={row.state}
                                    zipCode={row.zipCode}
                                  />
                                </TableCell>
                                <TableCell>
                                  <StoreManagerDetailsComponent
                                    storeOwnerName={row.storeOwnerName}
                                    storeOwnerPhoneNumber={
                                      row.storeOwnerPhoneNumber
                                    }
                                  />
                                </TableCell>
                                {/* <TableCell>{row.paymentAmount}</TableCell> */}
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  )}
                </div>
              ) : (
                <div className="w-full lg:w-2/3">
                  <div className="overflow-auto max-h-[500px]">
                    <h3 className="text-lg font-semibold mb-2 mx-4">{`Total Batches: ${availableBatches?.length}`}</h3>

                    {availableBatches.map((batch, index) => (
                      <Grid item xs={12} md={12} key={index} my={1} mx={2}>
                        <Accordion
                          expanded={expandedBatch === batch.batchTitle}
                        >
                          <AccordionSummary
                            expandIcon={
                              <IconButton
                                onClick={handleAccordionToggle(
                                  batch.batchTitle,
                                )}
                              >
                                <ExpandMoreIcon />
                              </IconButton>
                            }
                            aria-controls={`panel-${index}-content`}
                            id={`panel-${index}-header`}
                          >
                            <div className="flex items-center justify-between px-4 py-2 rounded-lg bg-white w-full">
                              {/* Section 1: Batch Title */}
                              <div className="flex">
                                <h1 className="text-lg font-bold">
                                  {batch.batchTitle}
                                </h1>
                              </div>

                              {/* Section 2: Other Details */}
                              <div className="flex items-center gap-6">
                                <span>{`Total jobs: ${batch?.jobs?.length}`}</span>
                                {/* Date Range - Formatted with Moment.js */}
                                <Chip
                                  className="text-sm"
                                  style={{ color: "gray" }}
                                  label={
                                    batch?.jobStartingDate &&
                                    batch?.jobCompletionDate
                                      ? `${moment(
                                          batch?.jobStartingDate,
                                        ).format("DD MMM YY")} - ${moment(
                                          batch?.jobCompletionDate,
                                        ).format("DD MMM YY")}`
                                      : "Date range not specified"
                                  }
                                />
                              </div>
                            </div>
                          </AccordionSummary>

                          <AccordionDetails>
                            {/* Render Job Details Table */}
                            <Box sx={{ overflow: "auto" }}>
                              <TableContainer
                                component={Paper}
                                sx={{
                                  borderRadius: "1rem",
                                  boxShadow: "none",
                                  maxWidth: "100%",
                                  overflowX: "auto",
                                }}
                              >
                                <Table sx={{ minWidth: 650, border: "none" }}>
                                  <TableHead>
                                    <TableRow
                                      sx={{
                                        backgroundColor: "#f9f9f9",
                                        borderRadius: "1rem",
                                      }}
                                    >
                                      <TableCell sx={tableCellStyle}>
                                        Address
                                      </TableCell>
                                      <TableCell sx={tableCellStyle}>
                                        Store Manager
                                      </TableCell>
                                      {/* <TableCell sx={tableCellStyle}>
                                 Job Pay
                               </TableCell> */}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {batch?.jobs?.map((row, index) => (
                                      <TableRow key={index}>
                                        <TableCell sx={tableCellStyle}>
                                          <div>
                                            {`${row.address},${row.city}, ${row.state}, ${row.zipCode}`}
                                          </div>
                                        </TableCell>
                                        <TableCell sx={tableCellStyle}>
                                          <div>{row.storeOwnerName}</div>
                                          <div>{row.storeOwnerPhoneNumber}</div>
                                        </TableCell>
                                        {/* <TableCell sx={tableCellStyle}>
                                   ₹{row.paymentAmount}
                                 </TableCell> */}
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      </Grid>
                    ))}
                  </div>
                  <div
                    className="flex justify-end mt-4 mx-4"
                    style={{ width: "200px" }}
                  >
                    <GlobalButton
                      variant="primary"
                      size="medium"
                      disabled={saveButtonActive}
                      onClick={() => {
                        setOpenConfirmationModal(true);
                      }}
                    >
                      {`Save Batches`}
                    </GlobalButton>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
      {openConfirmationModal && (
        <ConfirmationBeforeSaving
          saveCreatedBatches={saveCreatedBatches}
          setOpenConfirmationModal={setOpenConfirmationModal}
          openConfirmationModal
          serviceTypeDynamic={serviceTypeDynamic}
        />
      )}
    </div>
  );
};

export default ModalToCreateJobBatches;

const ConfirmationBeforeSaving = ({
  saveCreatedBatches,
  setOpenConfirmationModal,
  openConfirmationModal,
  serviceTypeDynamic,
}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [dots, setDots] = useState("");

  useEffect(() => {
    let interval;
    if (isSaving) {
      interval = setInterval(() => {
        setDots((prev) => (prev.length < 3 ? prev + "." : ""));
      }, 500);
    } else {
      setDots("");
    }

    return () => clearInterval(interval);
  }, [isSaving]);

  const handleClose = () => {
    if (!isSaving) setOpenConfirmationModal(false);
  };

  const handleSave = async () => {
    setIsSaving(true);
    await saveCreatedBatches();
    setIsSaving(false);
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "25%", // Adjusted width
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "8px",
  };

  const batchTypeText =
    serviceTypeDynamic === 0
      ? "recce"
      : serviceTypeDynamic === 1
        ? "installation"
        : serviceTypeDynamic === 2
          ? "audit"
          : "Supply";
  return (
    <Modal open={openConfirmationModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <div className="flex flex-col">
          <span>{`Are you sure you want to save following ${batchTypeText} Batches?`}</span>
          <div className="flex gap-2 mt-4 justify-end">
            <GlobalButton
              variant="secondary"
              size="small"
              onClick={handleClose}
              disabled={isSaving}
            >
              {`No thanks.`}
            </GlobalButton>
            <GlobalButton
              variant="primary"
              size="small"
              onClick={handleSave}
              isLoading={isSaving}
            >
              Yes, sure
              <span>!</span>
            </GlobalButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

const LocationAddressComponent = ({
  storeName,
  address,
  city,
  state,
  zipCode,
}) => {
  return (
    <div className="flex flex-col">
      <span>{storeName}</span>
      <span>{`${address}, ${city}, ${state}- ${zipCode}`}</span>
    </div>
  );
};
const StoreManagerDetailsComponent = ({
  storeOwnerName,
  storeOwnerPhoneNumber,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <span>{storeOwnerName}</span>
      <span>{storeOwnerPhoneNumber}</span>
    </div>
  );
};
